<script>
    /*
    	ExplorerServiceList.svelte
    */

    import { onMount } from 'svelte';
    import { push } from 'svelte-spa-router';
    
    // TCARE components
    import ExplorerServiceListItem from '../../components/lists/ExplorerServiceListItem.svelte';

    export let searchStore;
    export let onShowPopup;
    
    $: nonSortedResults = processResults($searchStore.filterResults);

    onMount(() => {
        // console.log('ExplorerServiceList onMount');
    })

    const processResults = (results) => {
        results = results;
        return results;
    }


</script>

<style>
    .service-list {
        /* height: calc(100vh - 250px); */
        width: 99%;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="service-list">
    {#if nonSortedResults && nonSortedResults.length > 0}
        {#each nonSortedResults as service}
            <ExplorerServiceListItem {service} {onShowPopup} />
        {/each}
    {/if}
</div>

